export default "__VITE_ASSET__BQIrcrxy__"